<template>
    <div id="service-staff-setting" class="shadow-md rounded-item">
        <vx-card>
            <div class="setting-card-hidden">
                <div class="setting-card-scroll">
                    <h4 class="text-2xl font-bold">Print On Clover</h4>
                    <div class="flex align-center">
                        <vs-switch v-model="is_print_on_clover" class="my-6" @click.stop="updatePrintOnClover"/>
                        <span class="pl-5">Allow to print on Clover device. This will also activate cash drawer.</span>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
export default {
    name: 'print-on-clover-setting',
    data() {
        return {
            is_print_on_clover: true,
            loaded_data_num: 0,
            isOpenLoading: false,
            action_type: ''
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get Data";
                    this.openLoadingInDiv();
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' Print On Clover Failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        updatePrintOnClover() {
            const obj = {
                key: 'config.pos.is_print_on_clover',
                value: !this.is_print_on_clover ? 1 : 0
            }
            this.action_type = 'Update';
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                title:'Notification',
                text:'Update Print On Clover Success',
                color:'success',
                position:'top-right'})
            });
        }
    },
    created() {
        const obj = {
            key: 'config.pos.is_print_on_clover'
        }

        this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
            this.loaded_data_num++;
            let is_print_on_clover = this.$store.getters["appSetting/keyStorage"];
            this.is_print_on_clover = is_print_on_clover.value == 1 ? true : false;
        }).catch(() => {
            const obj = {
                key: 'config.pos.is_print_on_clover',
                value: 1
            }
            this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
                this.loaded_data_num++;
            })
        })
    }
}
</script>